import { CopyIcon } from "@radix-ui/react-icons";
import { Globe, Phone } from "lucide-react";
import * as React from "react";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import {
  APP_CLIENT,
  CREATE_USER_ACOUNT,
  VERIFICATION_ELIGIBILITE,
} from "../../Utils/constant";
import mtn from "../../assets/images/logoT.png";
import CGU from "../../assets/model-fichier/cgu.pdf";
import Map from "../../components/Widget/Map";
import { store } from "../../services/service";

export const VerificationEligibilite = () => {
  const [gettingFile, setGettingFile] = useState(false);
  const [nomAbonne, setNomAbonne] = useState(null);
  const [numeroAbonne, setNumeroAbonne] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [username, setUsername] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);

  // États pour la recherche d'adresse
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const searchTimeoutRef = React.useRef(null);

  // Nouvel état pour contrôler le zoom de la carte
  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(null);

  const [error, setError] = useState(null);
  const [loadingLocalisation, setLoadingLocalisation] = useState(false);
  const [eligible, setEligible] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [comfirm, setComfirm] = useState(false);
  const [debouncedFieldLatitude, setDebouncedFieldLatitude] =
    useState(latitude);
  const [debouncedFieldLongitude, setDebouncedFieldLongitude] =
    useState(longitude);
  const navigate = useNavigate();

  // Fonction de recherche d'adresse avec l'API Nominatim
  const searchAddress = async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          query,
        )}&limit=5&addressdetails=1&countrycodes=ci`, // Limité à la Côte d'Ivoire
      );
      const data = await response.json();
      setSearchResults(data);
    } catch (error) {
      console.error("Erreur lors de la recherche d'adresse:", error);
      toast.error("Erreur lors de la recherche d'adresse");
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  // Gestion de la saisie avec débounce pour la recherche
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Annuler la recherche précédente
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Nouvelle recherche après 500ms
    searchTimeoutRef.current = setTimeout(() => {
      searchAddress(value);
    }, 500);
  };

  // Sélection d'une adresse depuis les résultats de recherche
  const handleAddressSelect = (address) => {
    const lat = parseFloat(address.lat);
    const lon = parseFloat(address.lon);

    setSelectedAddress(address);
    setLatitude(lat.toString());
    setLongitude(lon.toString());
    setUserLocation([lat, lon]);
    setSearchTerm(address.display_name);
    setSearchResults([]);

    // Nouveaux états pour le zoom automatique
    setMapCenter([lat, lon]);
    setMapZoom(15); // Niveau de zoom approprié pour voir les détails de l'adresse

    toast.success("Adresse sélectionnée");
  };

  // Effacer la recherche d'adresse
  const clearAddressSearch = () => {
    setSearchTerm("");
    setSearchResults([]);
    setSelectedAddress(null);
    // Réinitialiser le zoom
    setMapCenter(null);
    setMapZoom(null);
  };

  const handleClick = () => {
    setLoadingLocalisation(true);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoadingLocalisation(false);
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          setLatitude(lat);
          setLongitude(lon);
          setUserLocation([lat, lon]);
          setError(null);

          // Zoom automatique sur la position actuelle
          setMapCenter([lat, lon]);
          setMapZoom(15);

          // Effacer la recherche d'adresse lors de l'utilisation de la géolocalisation
          clearAddressSearch();
        },
        (error) => {
          setLoadingLocalisation(false);
          setError(error.message);
        },
        {
          timeout: 10000,
          maximumAge: 0,
          enableHighAccuracy: true,
        },
      );
    } else {
      setLoadingLocalisation(false);
      setError(
        "La géolocalisation n'est pas prise en charge par ce navigateur.",
      );
      console.error("Geolocation not supported by this browser.");
    }
  };

  const [isSubmit, setIsSubmit] = useState(longitude);

  const submit = () => {
    if (nomAbonne && numeroAbonne && latitude && longitude) {
      const data = {
        nomClient: nomAbonne,
        numeroClient: numeroAbonne,
        latitude,
        longitude,
      };
      setIsSubmit(true);
      store(VERIFICATION_ELIGIBILITE, "application/json", {
        ...data,
      })
        .then((res) => {
          if (res.status === 200) {
            setEligible(res?.data);
            toast.success("Vérification terminée");
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
          if (err && err.response && err.response.data) {
            toast.error(err?.response?.data?.donnee);
          } else {
            toast.error("Impossible de vérifier l'éligibilité");
          }
        });
    } else {
      toast.error("Renseigner tous les champs");
    }
  };

  const CreateAcount = () => {
    if (username && email && password) {
      const data = {
        nomPrenoms: nomAbonne,
        numero: numeroAbonne,
        email: email,
        username: username,
        password: password,
      };
      setIsSubmit(true);
      store(CREATE_USER_ACOUNT, "application/json", {
        ...data,
      })
        .then((res) => {
          if (res.status === 200) {
            toast.success("Compte creé");
            setIsSubmit(false);
            setComfirm(false);
            window.open(`${APP_CLIENT}/${eligible?.numeroTicket}`);
            resetVerification();
          }
        })
        .catch((err) => {
          setIsSubmit(false);
          if (err && err.response && err.response.data) {
            toast.error(err?.response?.data?.donnee);
          }
        });
    } else {
      toast.error("Renseigner tous les champs");
    }
  };

  const resetVerification = () => {
    setNomAbonne(null);
    setNumeroAbonne(null);
    setLatitude(null);
    setLongitude(null);
    setEligible(null);
    setUserLocation(null);
    setMapCenter(null);
    setMapZoom(null);
    clearAddressSearch();
  };

  React.useEffect(() => {}, []);

  // Update debouncedFieldOne after a delay
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFieldLatitude(latitude);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [latitude]);

  // Update debouncedFieldTwo after a delay
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFieldLongitude(longitude);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [longitude]);

  React.useEffect(() => {
    if (debouncedFieldLatitude || debouncedFieldLongitude) {
      if (
        latitude &&
        latitude.length >= 3 &&
        longitude &&
        longitude.length > 3
      ) {
        setUserLocation([latitude, longitude]);
      } else {
      }
    } else {
    }
  }, [debouncedFieldLatitude, debouncedFieldLongitude, latitude, longitude]);

  return (
    <div className="bg-white">
      <div className="bg-main">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-28 h-28 rounded-lg flex items-center justify-center">
                <img src={mtn} alt="" />
              </div>
              <div className="flex flex-col items-center">
                <h1 className="text-xl lg:text-3xl font-bold font-mtn text-black">
                  MTN Côte d'Ivoire
                </h1>
                <a
                  href={CGU}
                  target="blank"
                  className="underline text-xs text-black"
                >
                  Voir les Conditions Générales
                </a>
              </div>
            </div>
            <div className="hidden md:flex items-center space-x-6 text-sm">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>100 (Service Client)</span>
              </div>
              <div className="flex items-center space-x-2">
                <Globe className="w-4 h-4" />
                <span>www.mtn.ci</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="z-50 top-0 relative sticky bg-main h-20 flex items-center px-2">
        <img src={mtn} className="lg:w-fit h-10" alt="" srcset="" />
      </div> */}
      {comfirm === true ? (
        <>
          <div className="md:mt-4 flex justify-center items-center w-full">
            <div className="w-96 border shadow rounded-lg p-3">
              <>
                <p className="font-mtn text-2xl lg:text-3xl font-semibold mb-3">
                  Creation de compte
                </p>
                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                  <label className="form-control w-full">
                    <div className="label -mb-1">
                      <span className="label-text text-xs font-medium">
                        Nom d'utilisateur{" "}
                        <span className="text-red-500">*</span>
                      </span>
                    </div>
                    <input
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      type="text"
                      placeholder="Nom utilisateur"
                      className="input input-bordered w-full h-10 text-sm "
                    />
                  </label>
                </div>
                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                  <label className="form-control w-full">
                    <div className="label -mb-1">
                      <span className="label-text text-xs font-medium">
                        Email <span className="text-red-500">*</span>
                      </span>
                    </div>

                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="text"
                      placeholder="Numero client "
                      className="input input-bordered w-full h-10 text-sm "
                    />
                  </label>
                </div>

                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                  <label className="form-control w-full">
                    <div className="label -mb-1">
                      <span className="label-text text-xs font-medium">
                        Mot de passe <span className="text-red-500">*</span>
                      </span>
                    </div>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="********** "
                      className="input input-bordered w-full h-10 text-sm "
                    />
                  </label>
                </div>

                <button
                  disabled={isSubmit}
                  onClick={CreateAcount}
                  className="mt-3 block bg-main text-black btn btn-sm w-full h-10"
                >
                  {!isSubmit ? (
                    "Creer mon compte"
                  ) : (
                    <div className="flex flex-row items-center justify-center w-full">
                      <ThreeDots
                        height="20"
                        width="40"
                        radius="9"
                        color="#000"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={isSubmit}
                      />
                    </div>
                  )}
                </button>
              </>
            </div>
          </div>
        </>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 my-8 px-4 lg:px-28 gap-7">
          <div>
            <p className="my-2">Les zones de couverture de la FTTH</p>
            <Map
              userLocation={userLocation}
              setLatitude={setLatitude}
              setLongitude={setLongitude}
              setUserLocation={setUserLocation}
              mapCenter={mapCenter}
              mapZoom={mapZoom}
              onMapCenterChange={setMapCenter}
              onMapZoomChange={setMapZoom}
            />
          </div>
          <div className="md:mt-4">
            <p className="font-mtn text-2xl lg:text-3xl font-semibold ">
              Verification de l'éligibilité
            </p>

            {/* Recherche d'adresse améliorée */}
            <div className="bg-slate-50 border-2 rounded-xl p-4 my-4">
              <label className="block text-sm font-semibold mb-3">
                🔍 Rechercher une adresse
              </label>
              <div className="relative">
                <input
                  disabled={isSubmit || gettingFile}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  type="text"
                  placeholder="Ex: Cocody, Abidjan, Côte d'Ivoire"
                  className="w-full h-12 px-4 pr-10 border-2 border-blue-300 rounded-xl focus:border-blue-500 focus:outline-none transition-colors duration-200 bg-white"
                />
                {searchTerm && (
                  <button
                    onClick={clearAddressSearch}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors duration-200"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}
              </div>

              {/* Indicateur de chargement pour la recherche */}
              {isSearching && (
                <div className="mt-3 p-3 bg-white border border-blue-200 rounded-lg">
                  <div className="flex items-center justify-center space-x-2">
                    <ThreeDots
                      height="20"
                      width="40"
                      radius="9"
                      color="#3B82F6"
                      ariaLabel="three-dots-loading"
                    />
                    <span className="text-sm text-blue-600 font-medium">
                      Recherche en cours...
                    </span>
                  </div>
                </div>
              )}

              {/* Résultats de recherche */}
              {searchResults.length > 0 && (
                <div className="mt-3 bg-white border-2 rounded-xl max-h-48 overflow-y-auto shadow-lg">
                  {searchResults.map((result, index) => (
                    <button
                      key={index}
                      onClick={() => handleAddressSelect(result)}
                      className="w-full text-left px-4 py-3 hover:bg-blue-50 border-b border-blue-100 last:border-b-0 transition-colors duration-200 group"
                    >
                      <div className="font-semibold text-gray-900 group-hover:text-blue-800">
                        {result.name || result.display_name.split(",")[0]}
                      </div>
                      <div className="text-sm text-gray-600 truncate mt-1">
                        {result.display_name}
                      </div>
                    </button>
                  ))}
                </div>
              )}

              {/* Affichage de l'adresse sélectionnée */}
              {selectedAddress && (
                <div className="mt-3 bg-green-50 border-2 border-green-200 rounded-lg p-3">
                  <div className="flex items-start space-x-2">
                    <svg
                      className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <div>
                      <p className="text-sm font-semibold text-green-800">
                        Adresse sélectionnée :
                      </p>
                      <p className="text-sm text-green-700">
                        {selectedAddress.display_name}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="w-full mx-auto mt-6">
              {eligible === null ? (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Nom et prénoms <span className="text-red-500">*</span>
                      </label>
                      <input
                        disabled={isSubmit || gettingFile}
                        value={nomAbonne}
                        onChange={(e) => setNomAbonne(e.target.value)}
                        type="text"
                        placeholder="Votre nom complet"
                        className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-yellow-500 focus:outline-none transition-colors duration-200 bg-gray-50 focus:bg-white disabled:opacity-50"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Numéro <span className="text-red-500">*</span>
                      </label>
                      <input
                        disabled={isSubmit || gettingFile}
                        value={numeroAbonne}
                        onChange={(e) => setNumeroAbonne(e.target.value)}
                        type="number"
                        min={0}
                        placeholder="Votre numéro client"
                        className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-yellow-500 focus:outline-none transition-colors duration-200 bg-gray-50 focus:bg-white disabled:opacity-50"
                      />
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-4 my-2">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">
                      📍 Coordonnées géographiques
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-2">
                          Latitude <span className="text-red-500">*</span>
                        </label>
                        <input
                          disabled={isSubmit || gettingFile}
                          type="text"
                          value={latitude}
                          onChange={(e) => setLatitude(e.target.value)}
                          placeholder="Ex: 5.3364"
                          className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-yellow-500 focus:outline-none transition-colors duration-200 bg-white disabled:opacity-50"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-2">
                          Longitude <span className="text-red-500">*</span>
                        </label>
                        <input
                          disabled={isSubmit || gettingFile}
                          type="text"
                          value={longitude}
                          onChange={(e) => setLongitude(e.target.value)}
                          placeholder="Ex: -4.0267"
                          className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-yellow-500 focus:outline-none transition-colors duration-200 bg-white disabled:opacity-50"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Bouton géolocalisation */}
                  <button
                    disabled={isSubmit || gettingFile}
                    onClick={handleClick}
                    className="w-full h-12 bg-gray-800 text-white rounded-xl font-semibold hover:bg-gray-900 transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                  >
                    {!loadingLocalisation ? (
                      <>
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                        <span>
                          {latitude && longitude
                            ? "Mettre à jour ma position"
                            : "Obtenir ma position actuelle"}
                        </span>
                      </>
                    ) : (
                      <ThreeDots
                        height="20"
                        width="40"
                        radius="9"
                        color="#FFF"
                        ariaLabel="three-dots-loading"
                        visible={loadingLocalisation}
                      />
                    )}
                  </button>
                  <button
                    disabled={isSubmit || gettingFile}
                    onClick={submit}
                    className="block bg-main text-black btn btn-sm w-full h-10 my-1"
                  >
                    {!isSubmit ? (
                      "Verifier l'eligibilité"
                    ) : (
                      <div className="flex flex-row items-center justify-center w-full">
                        <ThreeDots
                          height="20"
                          width="40"
                          radius="9"
                          color="#000"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClassName=""
                          visible={isSubmit}
                        />
                      </div>
                    )}
                  </button>
                </>
              ) : (
                <div
                  className={`w-full mx-auto my-auto border ${
                    eligible?.fttheligible !== "eligible"
                      ? "border-red-600"
                      : "border-green-600"
                  } px-3 py-2 rounded mb-3`}
                >
                  <div className="flex gap-2">
                    <p className="text-lg font-semibold ">Status: </p>
                    <p
                      className={`text-lg font-bold ${
                        eligible?.fttheligible !== "eligible"
                          ? "text-red-600"
                          : "text-green-600"
                      }`}
                    >
                      {eligible?.fttheligible}{" "}
                    </p>
                  </div>

                  <div className="flex items-center gap-2">
                    <p className="text-lg font-semibold">Numero de ticket: </p>
                    <p
                      className={`text-lg font-bold ${
                        eligible?.fttheligible !== "eligible"
                          ? "text-red-600"
                          : "text-green-600"
                      }`}
                    >
                      {eligible?.numeroTicket}{" "}
                    </p>
                    <div className="bg-gray-200 p-1 rounded cursor-pointer">
                      <CopyToClipboard
                        text={eligible?.numeroTicket}
                        onCopy={() => toast.success("Texte copié")}
                      >
                        <span>
                          <CopyIcon />
                        </span>
                      </CopyToClipboard>
                    </div>
                  </div>

                  <button
                    onClick={resetVerification}
                    className="bg-main text-black btn btn-sm mt-4"
                  >
                    <h2>Nouvelle vérification</h2>
                  </button>
                  {eligible?.fttheligible === "eligible" ? (
                    <button
                      onClick={() => {
                        setComfirm(true);
                      }}
                      className="btn-main ml-2 text-black btn btn-sm mt-4"
                    >
                      <h2>Creer un compte</h2>
                    </button>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
